<template>
  <section class="section_banner">
    <!-- <Swiper v-if="isList">
      <SwiperSlide v-for="item in midBanners" :key="item.exhBannerSeq">
        <BannerPanel :data="item" />
      </SwiperSlide>
    </Swiper>
    <BannerPanel v-else-if="midBanners[0]" :data="midBanners[0]" /> -->
    <BannerPanel v-if="gnbBanners.length > 0" :data="gnbBanners[0]" />
  </section>
      <!-- /**
     * @example
     * {
        exhUrlTypeCd: null,
        exhBannerSeq: 259,
        exhUrlPath: null,
        editUser: 49,
        eventTypeCd: 'NORMAL',
        bannerName: '8월 구매 할수록 리워드!!',
        regDate: '2021-07-29T01:18:39.470+0000',
        bannerPosCd: 'GNB',
        sort: 1,
        displyaYn: 'Y',
        exhUrlStDate: '2021-07-28T15:00:00.000+0000',
        regUser: 49,
        editDate: '2021-07-29T01:18:49.150+0000',
        bgColor: '',
        imgAltText: '8월 구매 할수록 리워드!!',
        bannerTypeCd: 'EVENT',
        eventSeq: 282,
        exhUrlEdDate: '2021-08-31T14:00:00.000+0000',
        useYn: 'Y',
        bannerImg: 'https://biz.giftishow.com/files/BBS_20210729101839434.jpg',
      }
     */ -->
</template>

<script>
import { mapGetters } from 'vuex';

// import { Swiper, SwiperSlide } from '@/components/swiper';
import BannerPanel from './BannerPanel';

export default {
  components: {
    // Swiper,
    // SwiperSlide,
    BannerPanel,
  },

  computed: {
    ...mapGetters('home', ['gnbBanners']),
    // isList() {
    //   return this.midBanners?.length > 1
    // },
  },

  methods: {
    showAll() {
      this.showsAll = true;
    },
  },
};
</script>

<style>
</style>